module.exports = __webpack_public_path__ + "static/media/project3.20a854a1.jpeg";